import React from 'react';
import { Link } from 'react-router-dom';
import aboutImg from '../../assets/images/about-img.png';
import aboutBg from '../../assets/images/illustration/about-bg.svg';
import ListItem from './ListItem';

function About1() {
  return (
    <section
      className="about-wrapper section-padding bg-cover pb-0"
      style={{ backgroundImage: `url(${aboutBg})` }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="left-content bg-cover">
              <img src={aboutImg} alt="men" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-6 d-flex align-items-center">
            <div className="right-content">
              <div className="section-head">
                <span className="heading-bg">About</span>
                <h2 className="section-title">
                  We are the best-in-class products &amp; solutions
                  <span className="heading-dot" />
                </h2>
              </div>
              <p className="body-text">
                When developing a house project, specialists carefully work out
                the space, especially attentive to natural lighting. The main
                distinguishing The price of houses decorated in high-tech style
                is not the lowest, but they have a lot of positive qualities,
                which are:
              </p>
              <ul className="right-content-items">
                <ListItem listText=" Simplicity of form. Almost every house has a flat roof." />
                <ListItem listText="  Thoughtful lighting. Often, buildings provide panoramic." />
                <ListItem listText="  Original color. Before building a house, the future." />
              </ul>
              <Link to="/" className="button button-primary">
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About1;
